// src/App.js

import React from 'react';

import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

import PrivacyPolicy from './Components/PrivacyPolicy';

import AboutUs from './Components/AboutUs';

// This component is your new homepage.

// It contains the buttons/links to your other pages.

function Home() {

  return (

    <div>

      <h1>Welcome to GearOn!</h1>

      <p>This is the main page. Please use the links below to navigate.</p>

      <nav>

        {/* These links point to your existing pages without changing the URLs */}

        <Link to="/AboutUs" style={{ marginRight: '15px' }}>

          About Us

        </Link>

        <Link to="/PrivacyPolicy">

          Privacy Policy

        </Link>

      </nav>

    </div>

  );

}



// This component is for any page that doesn't exist.

function NotFound() {

  return (

    <div>

      <h2>404 - Page Not Found</h2>

      <p>Sorry, the page you are looking for does not exist.</p>

      <Link to="/">Go back to the Homepage</Link>

    </div>

  );

}

// This is the main App component that controls all the routing.

function App() {

  return (

    <Router>

      <div>

        <Routes>

          {/* Route 1: The Homepage (loads by default) */}

          <Route path="/" element={<Home />} />

          

          {/* Route 2 & 3: Your existing pages. The paths are unchanged. */}

          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />

          <Route path="/AboutUs" element={<AboutUs />} />
          {/* Fallback Route: Shows a 404 page for any other URL */}

          <Route path="*" element={<NotFound />} />

        </Routes>

      </div>

    </Router>

  );

}



export default App;
